const NotificationRoutes = {
  getNotifications: 'getNotifications',
  markAsRead: 'update_notification_status',
};

export default NotificationRoutes